import { render, staticRenderFns } from "./PrivacyDialog.vue?vue&type=template&id=38eb515c&scoped=true"
import script from "./PrivacyDialog.vue?vue&type=script&lang=js"
export * from "./PrivacyDialog.vue?vue&type=script&lang=js"
import style0 from "./PrivacyDialog.vue?vue&type=style&index=0&id=38eb515c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eb515c",
  null
  
)

export default component.exports